// Central config for the companion-product upsell. Update url/name/tagline here.
export const UPSELL = {
  name: "SaaS LaunchPad",
  url: "https://www.saaslaunchpad.org",
  tagline: "Take it further with SaaS LaunchPad — everything you need to launch your SaaS.",
  cta: "The Ultimate Builder Companion",
};
